<template>
  <div>
      <div class="title">
        <img v-if="refreshDom" class="title-bg" :src="file[fileId]" />
        <label class="title-text">{{ $t('News.bulletinBoard') }}</label>
      </div>
      <div class="page-wrapper">
        <BulletinList v-if="refreshNews" :newsList="newsList"/>
        <div>
          <label>{{ $t('News.pages', [this.lastPage]) }}/{{ $t('News.number', [this.totalNumber]) }}</label>
        </div>
        <b-pagination-nav
         pills
         first-number
         last-number
         align="right"
         :link-gen="getPaginate"
         :number-of-pages="lastPage"
        />
      </div>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from '@/api/config'
import BulletinList from '@/components/HomePage/BulletinList'
import { getFullNews } from '@/api/resourceAPI'
import { mapState, mapGetters } from 'vuex'

const NewsList = Vue.extend({
  name: 'NewsList',
  data: function () {
    let pagenateNumber = 2
    let list = []
    for (let i = 0; i < pagenateNumber; i++) {
      list.push({})
    }
    return {
      bg: require('../../assets/News/titlebg.jpg'),
      startList: list,
      newsList: list,
      refreshNews: false,
      lastPage: 1,
      totalNumber: 0,
      refreshDom: true,
      fileId: 1005
    }
  },
  components: {
    BulletinList
  },
  computed: {
    ...mapState({
      file: state => state.resource.file,
      status: state => state.resource.status
    }),
    ...mapGetters({
      isFileChange: 'resource/size'
    })
  },
  watch: {
    $route (to, from) {
      this.clearData()
      this.getData()
    },
    isFileChange () {
      this.refresh()
    }
  },
  mounted () {
    if (!this.$store.state.resource.status[this.fileId]) {
      this.$store.dispatch('resource/getFileType', this.fileId)
    }
    this.getData()
  },
  methods: {
    getPaginate (pageNum) {
      return { path: `/news/newsList/${pageNum}` }
    },
    getData () {
      let id = this.$route.path.split('/')[3]
      if (id === undefined) {
        id = 1
      }
      this.refreshNews = true
      axios.get(getFullNews + '?page=' + id)
        .then((res) => {
          this.setBaseData(res)
        })
    },
    clearData () {
      this.refreshNews = false
      this.newsList = this.startList
      this.$nextTick(() => {
        this.refreshNews = true
      })
    },
    setBaseData (res) {
      this.newsList = res.data.data.data
      this.lastPage = res.data.data.last_page
      this.totalNumber = res.data.data.total
    },
    refresh () {
      this.refreshDom = false
      this.$nextTick(() => {
        this.refreshDom = true
      })
    }
  }
})
export default NewsList
</script>

<style scoped>
.title {
    margin: 0;
    height: 310px;
    overflow: hidden;
}
.title-bg {
    padding: 0;
    size: 1920px 310px;
    overflow: hidden;
}
.title-text {
    position: absolute;
    left: 50%;
    top: 200px;
    transform: translateX(-50%);
    color: white;
    font-size: 3rem;
}
.pagination-nav-bar {
  top: 20px
}
</style>
